// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CampaignDetails-module__container___WTIl8 {
    margin: 8rem 8rem 1rem 8rem;
    display: grid;
    gap: 3rem;
    box-sizing: border-box;
    width: 100%;
    /**/ /*    height: calc(100vh - 20rem);
*/
    @media(width>700px) {
        grid-template-columns: minmax(0,1.2fr) minmax(0,3fr);
        margin: 8rem 4rem 0rem 4rem;
    }
}

.CampaignDetails-module__leftCol___q1imM {
    place-items: center;
    display: grid;
    grid-template-rows: 1fr 1fr min-content;
}

.CampaignDetails-module__chartCampaignDaysPlay___qfWL9 {
    grid-column: 1/-1;
}

.CampaignDetails-module__note___Vgq19 {
    color: #666666;
    margin-top: 1rem;
}

.CampaignDetails-module__footerNote___uGcRS {
    color: #666;
    font-size: 0.9em;
    margin: 4px 0;
}

/* Right column now single column; each composite chart row manages its own internal two-column layout like ".twoChartRow"*/
.CampaignDetails-module__rightCol___gVRhz {
    display: grid;
    grid-template-columns: minmax(0,1fr);
    row-gap: 1.25rem;
    align-items: center;

    @media(width>700px) {
        row-gap: 0rem;
    } 
}

/* Inner two-chart grid */
.CampaignDetails-module__twoChartRow___A0XOo {
    display: grid;
    grid-template-columns: minmax(0,1fr) minmax(0,1fr);
    column-gap: 1rem;
    align-items: stretch;
}

.CampaignDetails-module__twoChartRowFooter___oEHZT {
    grid-column: 1 / -1;
    margin-top: 4px;
}

/* stack charts vertically when no Campaign period graph is shown */
.CampaignDetails-module__twoChartRow___A0XOo.CampaignDetails-module__singleColumn___cwtQs {
    grid-template-columns: minmax(0,1fr);
    row-gap: 1rem;
}

/* Single-column layout helpers */
.CampaignDetails-module__regionBlock___iZ0mc {
    display: grid;
    row-gap: 0.35rem; 
}

.CampaignDetails-module__regionBlock___iZ0mc .CampaignDetails-module__footerNote___uGcRS {
    margin-top: 2px;
}

.CampaignDetails-module__chartBelow___P4DXP {
    margin-top: 1.4rem; /* extra spacing between first and second chart in single column */
}

/* Column panel headings (structural cue) */
.CampaignDetails-module__panelColumnHeading___vm9CY {
    font-family: 'BauerMediaSansBold', sans-serif;
    font-size: 1rem;
    margin: 0 0 0.5rem 0; /* small space below heading */
    color: #223;
}

.CampaignDetails-module__chartShadow___BVpkW {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
    padding: 1rem;
    top: 0;
    left: 0;
    display: flex; 
    flex-direction: column;
}

@media (min-aspect-ratio: 2) {
    .CampaignDetails-module__container___WTIl8 {
        margin: 8rem 7rem 1rem 7rem;
    }

    .CampaignDetails-module__chartShadow___BVpkW {
        padding: 0.5rem;
    }
}

/* Handle very high zoom levels (like 175%) or narrow screens */
@media (max-width: 1600px) and (min-width: 700px) {
    /* .chartShadow {
        max-height: 280px;
    } */

    .CampaignDetails-module__footerNote___uGcRS {
        font-size: 0.8em;
    }

    .CampaignDetails-module__twoChartRow___A0XOo{
        max-height: 300px;
    }

}`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/CampaignDetails/CampaignDetails.module.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,WAAW;IACX,GAAG,EAAE;CACR;IACG;QACI,oDAAoD;QACpD,2BAA2B;IAC/B;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA,2HAA2H;AAC3H;IACI,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;;IAEnB;QACI,aAAa;IACjB;AACJ;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,kDAAkD;IAClD,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA,mEAAmE;AACnE;IACI,oCAAoC;IACpC,aAAa;AACjB;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB,EAAE,kEAAkE;AAC1F;;AAEA,2CAA2C;AAC3C;IACI,6CAA6C;IAC7C,eAAe;IACf,oBAAoB,EAAE,8BAA8B;IACpD,WAAW;AACf;;AAEA;IACI,sGAAsG;IACtG,aAAa;IACb,MAAM;IACN,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,+DAA+D;AAC/D;IACI;;OAEG;;IAEH;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;AAEJ","sourcesContent":[".container {\n    margin: 8rem 8rem 1rem 8rem;\n    display: grid;\n    gap: 3rem;\n    box-sizing: border-box;\n    width: 100%;\n    /**/ /*    height: calc(100vh - 20rem);\n*/\n    @media(width>700px) {\n        grid-template-columns: minmax(0,1.2fr) minmax(0,3fr);\n        margin: 8rem 4rem 0rem 4rem;\n    }\n}\n\n.leftCol {\n    place-items: center;\n    display: grid;\n    grid-template-rows: 1fr 1fr min-content;\n}\n\n.chartCampaignDaysPlay {\n    grid-column: 1/-1;\n}\n\n.note {\n    color: #666666;\n    margin-top: 1rem;\n}\n\n.footerNote {\n    color: #666;\n    font-size: 0.9em;\n    margin: 4px 0;\n}\n\n/* Right column now single column; each composite chart row manages its own internal two-column layout like \".twoChartRow\"*/\n.rightCol {\n    display: grid;\n    grid-template-columns: minmax(0,1fr);\n    row-gap: 1.25rem;\n    align-items: center;\n\n    @media(width>700px) {\n        row-gap: 0rem;\n    } \n}\n\n/* Inner two-chart grid */\n.twoChartRow {\n    display: grid;\n    grid-template-columns: minmax(0,1fr) minmax(0,1fr);\n    column-gap: 1rem;\n    align-items: stretch;\n}\n\n.twoChartRowFooter {\n    grid-column: 1 / -1;\n    margin-top: 4px;\n}\n\n/* stack charts vertically when no Campaign period graph is shown */\n.twoChartRow.singleColumn {\n    grid-template-columns: minmax(0,1fr);\n    row-gap: 1rem;\n}\n\n/* Single-column layout helpers */\n.regionBlock {\n    display: grid;\n    row-gap: 0.35rem; \n}\n\n.regionBlock .footerNote {\n    margin-top: 2px;\n}\n\n.chartBelow {\n    margin-top: 1.4rem; /* extra spacing between first and second chart in single column */\n}\n\n/* Column panel headings (structural cue) */\n.panelColumnHeading {\n    font-family: 'BauerMediaSansBold', sans-serif;\n    font-size: 1rem;\n    margin: 0 0 0.5rem 0; /* small space below heading */\n    color: #223;\n}\n\n.chartShadow {\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n    padding: 1rem;\n    top: 0;\n    left: 0;\n    display: flex; \n    flex-direction: column;\n}\n\n@media (min-aspect-ratio: 2) {\n    .container {\n        margin: 8rem 7rem 1rem 7rem;\n    }\n\n    .chartShadow {\n        padding: 0.5rem;\n    }\n}\n\n/* Handle very high zoom levels (like 175%) or narrow screens */\n@media (max-width: 1600px) and (min-width: 700px) {\n    /* .chartShadow {\n        max-height: 280px;\n    } */\n\n    .footerNote {\n        font-size: 0.8em;\n    }\n\n    .twoChartRow{\n        max-height: 300px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CampaignDetails-module__container___WTIl8`,
	"leftCol": `CampaignDetails-module__leftCol___q1imM`,
	"chartCampaignDaysPlay": `CampaignDetails-module__chartCampaignDaysPlay___qfWL9`,
	"note": `CampaignDetails-module__note___Vgq19`,
	"footerNote": `CampaignDetails-module__footerNote___uGcRS`,
	"rightCol": `CampaignDetails-module__rightCol___gVRhz`,
	"twoChartRow": `CampaignDetails-module__twoChartRow___A0XOo`,
	"twoChartRowFooter": `CampaignDetails-module__twoChartRowFooter___oEHZT`,
	"singleColumn": `CampaignDetails-module__singleColumn___cwtQs`,
	"regionBlock": `CampaignDetails-module__regionBlock___iZ0mc`,
	"chartBelow": `CampaignDetails-module__chartBelow___P4DXP`,
	"panelColumnHeading": `CampaignDetails-module__panelColumnHeading___vm9CY`,
	"chartShadow": `CampaignDetails-module__chartShadow___BVpkW`
};
export default ___CSS_LOADER_EXPORT___;
